if ($('#roteiroButtonOpen').length == 1) {
    $(document).on('click', '#roteiroContent .box a.btn-close', function (e) {
        e.preventDefault();
        $('#roteiroContent').remove();
        $('#roteiroButtonOpen').toggle();
    });
    $(document).on('click', '#roteiroButtonOpen', function (e) {
        e.preventDefault();
        var urlRoteiro = $(this).attr('data-roteiro');
        $('body').append('<div id="roteiroContent">' +
            '<div class="box">' +
            '   <div id="roteiro-header">' +
            '       <div><img src="img/tria.svg" alt=""></div>' +
           // '       <a href="#" class="btn-minmax"><img src="img/menos.svg" alt=""></a>' +
            '       <a href="#" class="btn-close"><img src="img/close.svg" alt=""></a>' +
            '   </div>' +
            '   <iframe src="'+urlRoteiro+'" frameborder="0"></iframe>' +
            '</div>' +
            '</div>')
        $(this).toggle();
    });
}

$(document).ready(function () {
   setTimeout(function () {
       console.log('abre');
        $('#roteiroButtonOpen').addClass('active');
    }, 1250);
    setTimeout(function() {
        //console.log('fecha');
        //$('#roteiroButtonOpen').removeClass('active');
    }, 15000);
});
